import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as userService from '../../services/user';
import actions from './actions';
import toastr from 'toastr';
import {history} from "../../index";

export function* update({ payload }) {
  const { first_name, last_name, email, language_id } = payload;

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(userService.update, { first_name, last_name, email, language_id });

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'auth/SET_STATE',
      payload: {
        user: data.data,
      }
    });

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }

  if (response && response.status >= 400 && response.status <= 422) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        errors: response.data.error,
      }
    });
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* updatePassword({ payload }) {
  const { password_current, password, password_confirmation } = payload;

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: true,
      resetPasswordForm: false
    },
  });

  const response = yield call(userService.updatePassword, { password_current, password, password_confirmation });

  if (response && response.status === 200) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    yield put({
      type: 'user/SET_STATE',
      payload: {
        loadingDetails: false,
        resetPasswordForm: true
      },
    });
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }

    toastr.error(response.data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* list({ payload }) {
  const { page } = payload;

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingList: true,
    },
  });

  const response = yield call(userService.list, page);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'user/SET_STATE',
      payload: {
        list: data.data,
        meta: data.meta
      },
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingList: false,
    },
  })
}

export function* details({ payload }) {
  const { id } = payload;

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(userService.details, id);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'user/SET_STATE',
      payload: {
        details: data.data
      },
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* add({ payload }) {
  const response = yield call(userService.add, payload);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push('/users');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* edit({ payload }) {
  const { id, data } = payload;

  const response = yield call(userService.edit, id, data);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push('/users');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* remove({ payload }) {
  const { id, page } = payload;

  const response = yield call(userService.remove, id);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    return yield call(list.bind(null, { payload: { page: page ?? 1}}));
  }

  if (response && response.status >= 400 && response.status <= 422) {
    toastr.error(response.data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }
}

export function* refreshErrors() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PROFILE_UPDATE, update),
    takeEvery(actions.PASSWORD_UPDATE, updatePassword),
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
    takeEvery(actions.FETCH_ALL, list),
    takeEvery(actions.DETAILS, details),
    takeEvery(actions.ADD, add),
    takeEvery(actions.EDIT, edit),
    takeEvery(actions.REMOVE, remove),
  ])
}
